import type { DBTable, GetColumns } from '@analytical-alley/duckdb-react/types';
import { z } from 'zod';

export const competitorMediaInvestmentTableSchema = z.object({
    'Period name': z.string(),
});

export const competitorMediaInvestmentTableColumnsMap = {
    'Period name': 'periodName',
} as const;

type SchemaType = z.infer<typeof competitorMediaInvestmentTableSchema>;

export type CompetitorMediaInvestmentColumns = GetColumns<
    typeof competitorMediaInvestmentTableSchema,
    typeof competitorMediaInvestmentTableColumnsMap
>;

export type TCompetitorMediaInvestmentTableRow = DBTable<
    SchemaType,
    typeof competitorMediaInvestmentTableColumnsMap
>;

export const describeVariablesTableSchema = z.object({
    column_name: z.string(),
});

export const describeVariablesTableColumnsMap = {
    column_name: 'column_name',
} as const;

type DescribeSchemaType = z.infer<typeof describeVariablesTableSchema>;

export type TDescribeVariablesTableRow = DBTable<
    DescribeSchemaType,
    typeof describeVariablesTableColumnsMap
>;
